<template>
	<div class="phonegrid full" style="position: relative;">
		<div class="full" style="width: 0px;height: 0px;overflow: hidden;display: none;">
			<vxe-grid ref="vxegrid" v-bind="gridOptions"></vxe-grid>
		</div>
		<div class="full phonegrid_contaienr flex" ref="phonegrid">
			<div class="button_container flex" v-if="form || buttons.length!=0">
				<template v-if="form">
					<van-button type="info" size="" style="flex: 1;" @click="searchform">查询</van-button>
					<van-button type="default" size="" style="flex: 1;" @click="searchreset">重置</van-button>
				</template>
				<van-button v-if="buttons.length!=0 && type!='report'" type="primary" size="" style="flex: 1;"
					@click="actionShow=true">操作
				</van-button>
			</div>

			<van-list class="card_contaienr" v-model="loading" :finished="finished" finished-text="没有更多了"
				@load="onLoad">
				<component :is="selectTypeGroup" v-model="checked" direction="vertical">
					<div class="card" :style="cellStyle({row:row,column:columns})" v-for="(row,rowindex) in data"
						:key="rowindex">
						<component :class="{'van-radio__label':selectType=='div'}" :is="selectType"
							:name="row._X_ROW_KEY" :shape="selectType=='van-checkbox'?'square':'round'"
							:disabled="!checkMethod({row:row,column:columns})">
							<template v-for="(column,columnIndex) in columns">
								<template v-if="column.field!='flowstatus' && column.field!='auditorstaffid'">
									<template v-if="visiable(row,columnIndex)">
										<div class="card_item flex" :style="cellStyle({row:row,column:column})"
											:key="columnIndex" v-if="getColumnsVisiable(column.field)">
											<span
												style="font-weight: bolder;width: 80px;">{{getColumnsTitle(column.field)}}：</span>
											<template>
												<div style="flex: 1;">
													<quote v-if="column.editRender && column.editRender.props.penetrate"
														v-bind="column.editRender.props" :column="column" :row="row"
														:penetrate="true" :value="getColumnsValue(column.field,row)">
													</quote>
													<phoneupload
														v-else-if="column.editRender && column.editRender.name=='$upload'"
														:disabled="true"
														:value="getColumnsValue(column.field,row)" />
													<span v-else>{{getColumnsValue(column.field,row)}}</span>
												</div>
											</template>
										</div>
									</template>
								</template>
								<div v-else :key="columnIndex">
									<flowstatus style="display: inline-block;" v-if="column.field=='flowstatus'"
										:value="row[column.field]" :row="row" :moduleName="moduleName"></flowstatus>
									<auditorstaffid style="display: inline-block;" v-if="column.field=='auditorstaffid'"
										:value="row[column.field]">
									</auditorstaffid>
								</div>
							</template>
							<van-icon v-if="!visiable(row,columnIndex) && columns.length>visiableColumsNum"
								name="ellipsis" />
						</component>
						<div class="card_button flex">
							<template v-if="type=='table'">
								<van-button type="info" size="small" @click="editItem(row)">编辑</van-button>
								<!-- 								<van-button v-for="(item,index) in operate" :key="index" type="danger" size="small"
									style="margin-left: 10px;" @click="remove(row)">
									删除</van-button>	 -->
								<van-button v-for="(item,index) in operate" :key="index"
									:type="item.code=='del'?'danger':'warning'" size="small" style="margin-left: 10px;"
									@click="operateButtonClickEvent({code:item.code,data:row})">
									{{item.content}}
								</van-button>
							</template>
							<template v-if="type=='list'">
								<operateButton :table="this" @operateButtonClickEvent="operateButtonClickEvent"
									:operateButton="operateButton" :rendererList="rendererList" :row="row" />
							</template>
						</div>
						<div class="card_footer flex" v-if="columns.length>visiableColumsNum">
							<van-icon v-if="!visiable(row,columnIndex)" name="arrow-down" size="20px"
								@click="addVisiable(row)" />
							<van-icon v-else name="arrow-up" size="20px" @click="removeVisiable(row)" />
						</div>
					</div>
				</component>


			</van-list>
			<!-- 			<div class="box_footer flex">
				<van-button type="primary" size="" style="flex: 1;" @click="submit">确认</van-button>
			</div> -->
			<van-pagination v-if="pageneed!==false" v-model="page.currentPage" mode="simple"
				:page-count="Math.ceil(page.total/page.pageSize)" @change="pageChange" />
		</div>
		<van-action-sheet v-model="actionShow" :lazy-render="false">
			<slot name="actionSheet"></slot>
		</van-action-sheet>
		<van-popup v-model="searchformShow" position="top" :style="{ height: '50%' }" @opened="searchforminit"
			style="overflow: hidden;">
			<div class="searchform_container flex">
				<div style="flex: 1;overflow-y: auto;overflow-x: hidden;">
					<div class="" :ref="searchformRef"></div>
				</div>
				<div class="seaarchformfApa_footer flex">
					<van-button type="primary" style="flex: 1;" @click="search">确认</van-button>
					<van-button type="default" style="flex: 1;" @click="searchformShow=false">返回</van-button>
				</div>
			</div>
		</van-popup>
		<van-popup v-model="edithformShow" :style="{ height: '90%' ,width:'90%'}" :lazy-render="false"
			style="overflow: hidden;">
			<div class="searchform_container flex">
				<div style="flex: 1;overflow-y: auto;overflow-x: hidden;">
					<div :ref="editRef"></div>
				</div>
				<div class="seaarchformfApa_footer flex">
					<!-- 					<van-button type="primary" style="flex: 1;" @click="editSubmit">确认</van-button> -->
					<van-button type="default" style="flex: 1;" @click="edithformShow=false">返回</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<style>
	.card .van-radio__label {
		width: 100%;
		overflow: hidden;
	}

	.form-create .form-create .el-form-item {
		margin-bottom: 0px;
	}
</style>
<style scoped>
	.phonegrid_contaienr {
		flex-direction: column;

	}

	.button_container {
		height: 50px;
		box-sizing: border-box;

		justify-content: flex-end;
	}

	.box_footer {
		height: 50px;
		box-sizing: border-box;
	}

	.card_contaienr {
		position: relative;
		width: 100%;
		flex: 1;
		overflow-x: hidden;
		overflow-y: auto;
		box-sizing: border-box;
		padding: 10px;
	}

	.card {
		position: relative;
		width: 100%;
		border-radius: 2px;
		overflow: hidden;
		box-sizing: border-box;
		padding: 10px;
		box-shadow: 0px 0px 2px darkgrey;
		margin-bottom: 10px;
		font-size: 14px;
	}

	.card_body {
		position: relative;
		width: 100%;

	}

	.card_right {
		position: relative;
		flex-direction: row;
		width: 50px;
		height: 100%;
		align-items: center;
		justify-content: center;
	}

	.card_item {
		flex: 1;
		position: relative;
		/* 		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis; */
		margin-bottom: 10px;
	}

	.card_button {
		flex-direction: row;
		justify-content: flex-end;
		margin: 10px 0;
	}

	.card_footer {
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.searchform_container {
		height: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.seaarchformfApa_footer {
		width: 100%;
	}
</style>

<script>
	import operateButton from './operateButton.vue'
	import quote from '@_system/components/formcomponents/phone/quote/index.vue'
	import phoneupload from '@_system/components/formcomponents/phone/upload/index.vue'
	import flowstatus from '@_system/components/formcomponents/phone/flowstatus/index.vue'
	import auditorstaffid from '@_system/components/formcomponents/phone/auditorstaffid/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			formToolbarConfig: {
				default: () => {
					return []
				}
			},
			gridOptions: {
				default: () => {
					return null
				}
			},
			operateButton: {
				default: () => {
					return null
				}
			},
			fields: {
				default: () => {
					return null
				}
			},
			type: {
				default: () => {
					return ''
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},
			
		},
		data() {
			return {
				sourcedata: [],
				loading: false,
				finished: true,
				searchformRef: 'formsearch' + Math.random(),
				seaarchformfApi: null,
				data: [],
				pageneed: false,
				page: {
					currentPage: 1,
					pageSize: 1,
					total: 0,
				},
				form: null,
				columns: [],
				selectTypeGroup: 'div',
				selectType: 'div',
				checked: [],
				// radio: '',
				// checkbox: [],
				searchformShow: false,
				actionShow: false,
				buttons: [],
				operate: [],
				tableToolbarButtons: [],
				visiableColumsNum: 10,
				visiableColumsRow: [],

				editRule: null,
				edithformShow: false,
				editRef: 'edit_' + Math.random()
			}
		},
		created() {
			if (this.gridOptions) {
				this.pageneed = this.gridOptions.pagerConfig.enabled
				this.gridOptions.proxyConfig.autoLoad = false
				// this.gridOptions.formConfig.enabled = false
				this.init()
			}
		},
		mounted() {
			if (this.type == 'list' || this.type == 'report') {
				this.commitProxy('query')
			}
			this.store.table = this.$refs.vxegrid
			this.store.container = this

		},
		watch: {
			data(v) {
				this.$emit('dataChange', {
					data: v,
					page: this.page,
					type: this.type,
					pageneed: this.pageneed
				})
			},
			checked(v) {
				let row = null
				if (Array.isArray(v)) {
					row = this.data.filter((item) => {
						return v.includes(item._X_ROW_KEY)
					})
					this.$refs.vxegrid.clearCheckboxRow()
					this.$refs.vxegrid.setCheckboxRow(row, true)
				} else {
					row = this.data.find((item) => {
						return item._X_ROW_KEY == v
					})
					if (row) {
						this.$refs.vxegrid.setRadioRow(row)
					} else {
						this.$refs.vxegrid.clearRadioRow()
					}
				}

			}
		},
		computed: {

		},

		methods: {
			init() {
				if (this.fields) {
					let obj = {
						data: null,
						fApi: null,
						rule: this.fields,
						option: {
							form: {
								title: false,
								labelWidth: "0px",
								hideRequiredAsterisk: false,
								showMessage: false,
								inlineMessage: false
							},
							global: {
								"*": {
									props: {
										el: true,
										size: "mini",
										disabled: false
									},
									col: {
										span: 24,
										offset: 0
									}
								},
								"el-divider": {
									wrap: {
										show: true
									},
									native: false,
									col: {
										span: 24,
										offset: 0
									},
									props: {
										contentPosition: "left"
									}
								}
							},
							submitBtn: false,
							resetBtn: false
						}
					}
					this.editRule = obj
					this.fields.forEach((item) => {
						if (item.type == 'ElInputNumber') {
							item.type = '$inputNumber'
						}
						if (item.type == 'ElInput') {
							item.type = '$input'
						}
						item.on = {
							change: (e) => {
								this.editRule.data[item.field] = e
								let formData = this.editRule.fApi.bind()
								for (let i in formData) {
									formData[i] = this.editRule.data[i]
								}
								this.$emit('tablefieldChange', {
									itemProps: item.props,
									// store: this.store,
									// table: this.$refs.vxegrid,
									// moduleName: this.moduleName,
									data: {
										row: this.editRule.data,
										column: item
									}
								})
								this.$nextTick(() => {
									this.updateData()
								})
							}
						}
					})
				}

				if (this.gridOptions.formConfig) {
					let form = {}
					this.gridOptions.formConfig.items.forEach((item) => {
						form[item.field] = ''
					})
					this.form = form
				}
				if (this.gridOptions.toolbarConfig) {
					let buttons = []
					this.gridOptions.toolbarConfig.buttons.forEach((item) => {
						if (item.visible !== false) {
							buttons.push(item)
						}
					})
					this.buttons = buttons
				}

				this.tableToolbarButtons = this.gridOptions.tableToolbarButtons

			},
			getColumnsVisiable(field) {
				let index = this.columns.findIndex((item) => {
					return item.field == field
				})
				return index !== -1 ? true : false
			},
			getColumnsTitle(field) {
				let index = this.columns.findIndex((item) => {
					if (item.field == field) {
						return true
					}
				})
				if (index !== -1) {
					return this.columns[index].title
				}
			},
			getColumnsValue(field, row) {

				let componentname = null
				let editRender = null
				let index = this.columns.findIndex((item) => {
					return item.field == field
				})
				// if(field=='collection_time'){
				// 	console.log(row.collection_time,)
				// }
				if (index !== -1) {
					editRender = this.columns[index].editRender ? this.columns[index].editRender.name : null
					if (editRender) {
						componentname = editRender.replace(/^\$/, '')
					}
				}

				if (index !== -1 && this.columns[index].formatter) {
					return this.columns[index].formatter({
						row
					})

				} else if (componentname && Object.prototype.hasOwnProperty.call(window.systemData, componentname)) {

					return window.systemMethods['get' + componentname](row[field])
				} else {
					return row[field]
				}
			},
			cellStyle(obj) {
				if (this.gridOptions.cellStyle) {
					//console.log(this.gridOptions.cellStyle(obj))
					return this.gridOptions.cellStyle(obj)
				} else {
					return null
				}
			},
			checkMethod(obj) {
				if (this.gridOptions.checkboxConfig && this.gridOptions.checkboxConfig.checkMethod) {
					//console.log(this.gridOptions.cellStyle(obj))
					return this.gridOptions.checkboxConfig.checkMethod(obj)
				} else {
					return true
				}
			},
			editItem(row) {
				this.editRule.option.el = this.$refs[this.editRef]
				this.editRule.rule.forEach((item) => {
					item.value = row[item.field]
				})
				if (!this.editRule.fApi) {
					this.editRule.fApi = this.$formCreate(this.editRule.rule, this.editRule.option)
				}
				this.editRule.fApi.rowSourceData = row
				this.editRule.data = row
				this.edithformShow = true
				//console.log(this.editRule,123)
			},

			visiable(row, columnIndex) {
				let objIndex = this.visiableColumsRow.findIndex((item) => {
					return row._X_ROW_KEY == item
				})
				if (columnIndex < this.visiableColumsNum || objIndex !== -1) {
					return true
				} else {
					return false
				}
			},
			addVisiable(row) {
				this.visiableColumsRow.push(row._X_ROW_KEY)
			},
			removeVisiable(row) {
				this.visiableColumsRow = this.visiableColumsRow.filter((item) => {
					return item != row._X_ROW_KEY
				})
			},
			clearCheckboxRow() {
				this.checked = []
				this.$refs.vxegrid.clearRadioRow()
				this.$refs.vxegrid.clearCheckboxRow()
			},
			searchform(e) {
				e.stopPropagation()
				this.searchformShow = true
			},
			searchforminit() {
				let items = this.gridOptions.formConfig.items
				let obj = {}
				obj.width = '100%'
				obj.height = 'auto'
				obj.fApi = []
				obj.rule = [{
					"type": "el-divider",
					"children": [
						"选项"
					]
				}, ]
				obj.option = {
					form: {
						labelWidth: '0',
						hideRequiredAsterisk: false,
						showMessage: false,
						inlineMessage: false,
						title: false
					},
					global: {
						'*': {
							props: {
								el: false,
								size: 'mini',
								disabled: false
							},
							col: {
								span: 24,
								offset: 0
							}
						}
					},
					submitBtn: false,
					resetBtn: false
				}
				items.forEach((item) => {
					if (item.field && item.field != 'flowstatus') {
						let itemObj = {
							virtual: false,
							type: item.itemRender.name,
							field: item.field,
							title: item.title,
							value: item.itemRender.defaultValue ? item.itemRender.defaultValue : null,
							props: item.itemRender.props,
							options: item.itemRender.options,
							col: [],
							style: [],
							width: '100%',
							fixed: false,
							hidden: false,
							children: [],
							validate: [{
								required: false,
								message: '必填项'
							}]

						}
						obj.rule.push(itemObj)
					}
				})
				obj.option.el = this.$refs[this.searchformRef]
				if (!this.seaarchformfApi) {
					this.seaarchformfApi = this.$formCreate(obj.rule, obj.option)
				}

			},
			search() {
				let formData = this.seaarchformfApi.formData()
				let form = this.$refs.vxegrid.getProxyInfo().form
				for (let i in form) {
					if (formData[i]) {
						form[i] = formData[i]
						if (i.match(/.*staffid$/g)) {
							form[i] = [formData[i]]
						}
						if (i.match(/.*departmentid$/g)) {
							form[i] = [formData[i]]
						}
					}

				}

				this.searchformShow = false
				this.commitProxy('query')
			},
			searchreset() {
				if (this.seaarchformfApi) {
					this.seaarchformfApi.resetFields()
					let form = this.$refs.vxegrid.getProxyInfo().form
					for (let i in form) {
						form[i] = null
					}
				}
				this.page.currentPage = 1
				this.page.pageSize = 20
				this.getProxyInfo().pager = this.page
				this.searchformShow = false
				this.commitProxy('query')
			},
			operateButtonClickEvent(e) {
				this.$emit('operate-button-click', e)
			},
			toolbarButtonClickEvent(e) {
				this.$emit('toolbar-button-click', e)
			},



			pageChange(e) {
				this.getProxyInfo().pager.page = e
				this.commitProxy('query')
			},
			actionHide() {
				this.actionShow = false
			},
			//=====================

			getProxyInfo() {
				return this.$refs.vxegrid.getProxyInfo()
			},
			getRadioRecord() {

				return this.$refs.vxegrid.getRadioRecord()
			},
			getCheckboxRecords() {
				return this.$refs.vxegrid.getCheckboxRecords()
			},
			getTableData() {
				return this.$refs.vxegrid.getTableData()
			},
			// getData() {
			// 	return this.$refs.vxegrid.getTableData()
			// },
			onLoad() {

			},
			reloadData(data) {
				this.$refs.vxegrid.reloadData(data)
			},
			getRecordset() {
				return this.$refs.vxegrid.getRecordset()
			},
			validate(all, callback) {
				return this.$refs.vxegrid.validate(all, callback)
			},

			commitProxy(code, param = {}) {
				if (code == 'query') {
					this.data = []
					this.loading = true
					this.finished = false
					return new Promise((reslove, reject) => {
						this.$refs.vxegrid.commitProxy('query', param).then(() => {
							this.updateData()
							this.page = this.getProxyInfo().pager
							this.loading = false
							this.finished = true
							reslove()
						}, () => {
							reject()
							this.page = this.getProxyInfo().pager
							this.loading = false
							this.finished = true
						})
					})
				}
			},

			insertAt(e) {
				return new Promise((reslove) => {
					this.$refs.vxegrid.insertAt(e).then((param) => {
						this.updateData()
						reslove(param)
					})
				})
			},
			remove(row = false) {
				if (row) {
					this.$refs.vxegrid.remove(row).then(({
						row
					}) => {
						this.updateData()
						this.$emit('aftertabledelete', {
							obj: row
						})
					})
				} else {
					this.$refs.vxegrid.remove().then(({
						row
					}) => {
						this.updateData()
						this.$emit('aftertabledelete', {
							obj: row
						})
					})
				}
			},
			updateData() {
				this.columns = []
				this.operate = []
				this.$refs.vxegrid.getColumns().forEach((item) => {
					if (item.type == 'radio') {
						this.selectTypeGroup = 'van-radio-group'
						this.selectType = 'van-radio'
					}
					if (item.type == 'checkbox') {
						this.selectTypeGroup = 'van-checkbox-group'
						this.selectType = 'van-checkbox'
					}
					if (item.visible && item.field) {
						this.columns.push(item)
					}
					if (!item.field && item.cellRender) {
						//this.operate.push(item)
						this.operate = item.cellRender.buttons
					}
					//console.log(this.operate)
				})

				this.data = this.$refs.vxegrid.getTableData().fullData
				if (this.editRule && this.editRule.fApi) {
					let rowSourceData = this.editRule.fApi.rowSourceData
					let row = this.$refs.vxegrid.getTableData().fullData.find((item) => {
						return item._X_ROW_KEY == rowSourceData._X_ROW_KEY
					})
					if (row) {
						this.editRule.fApi.setValue(row)
						this.editRule.data = row
						this.editRule.rowSourceData = row
					}
				}



				//console.log(this.data)

			}
		},
		components: {
			operateButton,
			quote,
			flowstatus,
			auditorstaffid,
			phoneupload
		}
	}
</script>